import { render, staticRenderFns } from "./RejectedTable.vue?vue&type=template&id=21b9b965"
import script from "./RejectedTable.vue?vue&type=script&lang=ts"
export * from "./RejectedTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports